import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Config from '../../../config/config';
import { refreshAccessToken } from '../../Authorization/authSlice';

const serverPath = Config.serverPath;
export const loadMenuNodes = createAsyncThunk(
    "menuSide/loadMenuNodes",
    async (id, thunkApi) => {
      const {dispatch} = thunkApi;
      const urlMenuData = serverPath + "/api/menudata/";
      const response = await fetch(urlMenuData, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
       
        credentials: 'include',
        mode: 'cors',
    });

      /*const urlCategory = serverPath + "/api/category/";
      const urlSubCategory = serverPath + "/api/subcategory/";
      const urlQuizes = serverPath + "/api/quizes/";

      const responseCategory = await fetch(urlCategory);
      const responseSubCategory = await fetch(urlSubCategory);
      const responseQuizes = await fetch(urlQuizes);*/
      
      let dataMenuNodes = [];

      
     /* if (responseCategory.ok & responseSubCategory.ok & responseQuizes.ok) {
        const jsonResponseCategory = await responseCategory.json();
        const jsonResponseSubCategory = await responseSubCategory.json();
        const jsonResponseQuizes = await responseQuizes.json();*/

        if (response.ok) {

          const  jsonResponse = await response.json();
          console.log(jsonResponse);
          const jsonResponseCategory = jsonResponse.categories;
          const jsonResponseSubCategory = jsonResponse.subcategories;
          const jsonResponseQuizes = jsonResponse.quizes;




        const data = [];
        const subdata = [];

        jsonResponseCategory.map(element => {
          data.push(element);
          return element.nodes = [];
        })
        jsonResponseSubCategory.map(element => {
          subdata.push(element);
         return element.nodes = [];
        })
       console.log(subdata);

        /*
        jsonResponseQuizes.map(element => {
          subdata[element.id_category - 1].nodes.push(element);
        })
*/      subdata.map(subcategory => {
         return jsonResponseQuizes.map(element => {
            if (element.id_category === subcategory.id) {
              element.marker = true; //MARKER FOR SHOW THAT IT IS QUIZ!!!! 
              subcategory.nodes.push(element);
            } else {return null;}
            return element;
            
          })
        });
        

        //console.log("dddd");       
        console.log(subdata);
        data.map(category => {
             return subdata.map(element => {
            if (category.id === element.id_category) {

            category.nodes.push(element);} else return null;
            return element;
          });
          
        })
        


        dataMenuNodes = data;
       // console.log(data);
       return dataMenuNodes;
        } else if (response.status === 401) {
                  
                    console.log('401 -refresh access token!');
                    try {
                        const result = await dispatch(refreshAccessToken());
                      //IF ACCESS AND REFRESH TOKEN BAD
                        console.log(result.payload);
                        if (result.payload) {
                           // console.log('GOOD ACCESS!!!!');
                          dispatch(loadMenuNodes());
                        } else {
                            console.log('Bad refresh access');
                        }
                    } catch (e) {
                        console.log('Error');
                    };
        
        
        
                }
        else {
           
          console.log('BAD GET menu data');
        return response.status;
        } 
    }
);
export const loadMenuNodesPrivate = createAsyncThunk(
  "menuSide/loadMenuNodesPrivate",
  async (id, thunkApi) => {
    const {dispatch} = thunkApi;
    const urlMenuData = serverPath + "/api/menudataprivate/";
    const urlToFetch = `${urlMenuData}${id}`;
    const response = await fetch(urlToFetch, {
      method: 'GET',
      headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
      },
     
      credentials: 'include',
      mode: 'cors',
  });

    /*const urlCategory = serverPath + "/api/category/";
    const urlSubCategory = serverPath + "/api/subcategory/";
    const urlQuizes = serverPath + "/api/quizes/";

    const responseCategory = await fetch(urlCategory);
    const responseSubCategory = await fetch(urlSubCategory);
    const responseQuizes = await fetch(urlQuizes);*/
    
    let dataMenuNodes = [];

    
   /* if (responseCategory.ok & responseSubCategory.ok & responseQuizes.ok) {
      const jsonResponseCategory = await responseCategory.json();
      const jsonResponseSubCategory = await responseSubCategory.json();
      const jsonResponseQuizes = await responseQuizes.json();*/

      if (response.ok) {

        const  jsonResponse = await response.json();
        console.log(jsonResponse);
        const jsonResponseCategory = jsonResponse.categories;
        const jsonResponseSubCategory = jsonResponse.subcategories;
        const jsonResponseQuizes = jsonResponse.quizes;




      const data = [];
      const subdata = [];

      jsonResponseCategory.map(element => {
        data.push(element);
        return element.nodes = [];
      })
      jsonResponseSubCategory.map(element => {
        subdata.push(element);
       return element.nodes = [];
      })
     console.log(subdata);

      /*
      jsonResponseQuizes.map(element => {
        subdata[element.id_category - 1].nodes.push(element);
      })
*/      subdata.map(subcategory => {
       return jsonResponseQuizes.map(element => {
          if (element.id_category === subcategory.id) {
            element.marker = true; //MARKER FOR SHOW THAT IT IS QUIZ!!!! 
            subcategory.nodes.push(element);
          } else {return null;}
          return element;
          
        })
      });
      

      //console.log("dddd");       
      //console.log(subdata);
      data.map(category => {
           return subdata.map(element => {
          if (category.id === element.id_category) {
          category.nodes.push(element);} else return null;
          return element;
        });
        
      })
      


      dataMenuNodes = data;
     // console.log(data);
     return dataMenuNodes;
      } else if (response.status === 401) {
                
                  console.log('401 -refresh access token!');
                  try {
                      const result = await dispatch(refreshAccessToken());
                    //IF ACCESS AND REFRESH TOKEN BAD
                      console.log(result.payload);
                      if (result.payload) {
                         // console.log('GOOD ACCESS!!!!');
                        dispatch(loadMenuNodesPrivate(id));
                      } else {
                          console.log('Bad refresh access');
                      }
                  } catch (e) {
                      console.log('Error');
                  };
      
      
      
              }
      else {
         
        console.log('BAD GET menu data');
      return response.status;
      } 
  }
);

const initialState = {
  categoryView: false,
        idCategory: 0,
        firstContentView: true,
        quizView: false,
        quizActive: false,
        dataMenuNodes: [],
        dataMenuNodesPrivate: [],
        dataMenuNodesLength: [],
        isFetching: false,
        error: "",
        accountView: false,
        favoritesView: false,
        libraryView: false,
        troublesView: false,
        notesView: false,
        contactsView: false,
        messagesView: false,
        selectedModule: null,
       // previousModule: null,
        menuSideView: false,
        taskView: false,
        taskMineView: false,
        subscriberView: false
}





 const options= {
    name: 'menuSide',

    initialState: {
        
        idCategory: 0,
        
        
        dataMenuNodes: [],
        isFetching: false,
        error: "",

        firstContentView: true,
        accountView: false,
        favoritesView: false,
        categoryView: false,
       // categoryPrivateView: false,
        quizView: false,
        quizActive: false,
        libraryView: false,
        troublesView: false,
        notesView: false,
        contactsView: false,
        messagesView: false,

        selectedModule: null,
        previousModule: null,
        menuSideView: false,
        taskView: false,
        taskMineView: false,
        subscriberView: false
    },

    reducers: {
        // GET first INITIAL STATE
        getInitialStateMenu: state  => 
               initialState,
        
        closeAllView: state => {
        state.categoryView = false;
        //state.categoryPrivateView = false;
        state.quizView = false;
        state.accountView =  false;
        state.favoritesView =  false;
        state.libraryView = false;
        state.troublesView = false;
        state.notesView = false;
        state.contactsView = false;
        state.messagesView = false;
        state.firstContentView = false;
        state.taskView = false;
        state.taskMineView = false;
        state.subscriberView = false;
        }

        ,
        closeAllViewCloseQuizActive: state => {
          state.categoryView = false;
         // state.categoryPrivateView = false;
          state.quizView = false;
          state.accountView =  false;
          state.favoritesView =  false;
          state.libraryView = false;
          state.troublesView = false;
          state.notesView = false;
          state.contactsView = false;
          state.messagesView = false;
          state.firstContentView = false;
          state.quizActive = false;
          state.taskView = false;
          state.taskMineView = false;
          state.subscriberView = false;
          }
  
          ,  
        getInitialStateWithPreviousView: state => {
          state.idCategory = 0;
        
        
         // state.dataMenuNodes = [];
         // state.isFetching = false;
         // state.error = "";

          state.firstContentView = false;
          state.accountView = false;
          state.favoritesView = false;
          state.categoryView = false;
         // state.categoryPrivateView = false;
          state.quizView = false;
          state.libraryView = false;
          state.troublesView = false;
          state.notesView = false;
          state.contactsView = false;
          state.messagesView = false;
          state.quizActive = false;
          state.taskView = false;
          state.taskMineView = false;
        
          state.menuSideView = false;
          state.subscriberView = false;
        },      
               
        addMenuNodes: (state, action) => {
            
            return { 
                categoryView: true,
                idCategory: action.payload,
                firstContentView: false,
                quizView: false,
                

                }
            },
        showFirstContentView: (state, action) => {
                
                    state.firstContentView = true;
                    
                 
                },
        closeFirstContentView: (state, action) => {
                
                  state.firstContentView = false;
                  
               
              },                
        closeCategoryView: (state, action) => {
          state.categoryView = false;
        },
        openCategoryView: (state, action) => {
          state.categoryView = true;
        },
        showCategoryView: (state, action) => {
          state.categoryView = true;
        },
        showAccount: (state, action) => {
          state.firstContentView = false;
          state.accountView = true;
        },
        showFavorites: (state, action) => {
          state.firstContentView = false;
          state.favoritesView = true;
        },
        showMessages: (state, action) => {
          state.firstContentView = false;
          state.messagesView = true;
        },
        showLibrary: (state, action) => {
          state.firstContentView = false;
          state.libraryView = true;
        },
        showTroubles: (state, action) => {
          state.firstContentView = false;
          state.troublesView = true;
        },
        showNotes: (state, action) => {
          state.firstContentView = false;
          state.notesView = true;
        },
        closeNotes: (state, action) => {
           //state.firstContentView = false;
           state.notesView = false;
           state.quizActive = false;
         },
         closeTroubles: (state, action) => {
          // state.firstContentView = false;
           state.troublesView = false;
         },
         showContacts: (state) => {
          state.firstContentView = false;
          state.contactsView = true;
         },
         closeContacts : (state) => {
          state.contactsView = false;
         },
         setSelectModule: (state, action) => {
          state.selectedModule = action.payload;
          console.log(action.payload);
         },
         setPreviousModule: (state, action) => {
          state.previousModule = state.selectedModule;
         },
         setSelectedModulePrevious: (state, action) => {
          state.selectedModule = state.previousModule;
         },
         showMenuView: (state) => {
          state.menuSideView = !state.menuSideView;
         },
        
         closeQuizActive: (state) => {
          state.quizActive = false;
         },

         showView: (state, action) => {
          const numberOfModule = Number(action.payload);
          state.selectedModule = action.payload;

          // SHOW VIEWS

          if (numberOfModule === 1) {
            state.firstContentView = true;

          };
          if (numberOfModule === 2 || numberOfModule === 13) {
            state.categoryView = true;

          };
          if (numberOfModule === 3) {
            state.quizView = true;
            state.quizActive = true;
          };
          if (numberOfModule === 33) {
            state.notesView = true;
          };
          if (numberOfModule === 4) {
            state.libraryView = true;

          };
          if (numberOfModule === 7) {
            state.accountView = true;

          };
          if (numberOfModule === 6) {
            state.subscriberView = true;

          };
          if (numberOfModule === 8) {
            state.favoritesView = true;

          };
          if (numberOfModule === 9) {
            state.messagesView = true;

          };
          if (numberOfModule === 10) {
            state.contactsView = true;

          };
          if (numberOfModule === 11) {
            state.taskView = true;

          };
          if (numberOfModule === 14) {
              state.troublesView = true;
  
          };
          if (numberOfModule === 15) {
              state.taskMineView = true;
  
          };
         },
         

           
        }
        ,
        extraReducers(builder){
          builder
           .addCase(loadMenuNodes.pending,(state, action) => {

              state.isFetching = true;
              state.error = false;
           })
           .addCase(loadMenuNodes.fulfilled,(state, action) => {

            if (action.payload) {

              state.dataMenuNodes = action.payload;
              state.isFetching = true;
              state.error = false;
              state.categoryView = true;

              state.firstContentView = false;
              state.quizView = false;
            }

          })
          .addCase(loadMenuNodes.rejected, (state, action) => {

            state.isFetching = false;
            state.error = action.payload;

          })
          .addCase(loadMenuNodesPrivate.pending,(state, action) => {

            state.isFetching = true;
            state.error = false;
         })
         .addCase(loadMenuNodesPrivate.fulfilled,(state, action) => {

          if (action.payload) {
            state.dataMenuNodesPrivate = action.payload;
            state.isFetching = true;
            state.error = false;
            state.categoryView = true;
           // state.categoryPrivateView = true;

            state.firstContentView = false;
            state.quizView = false;
          }

        })
        .addCase(loadMenuNodesPrivate.rejected, (state, action) => {

          state.isFetching = false;
          state.error = action.payload;

        })
        }
    
    };
    
    export const menuSideSlice = createSlice(options);
    export const  { closeNotes, closeTroubles, showNotes ,showTroubles ,showLibrary ,showFavorites,closeAllView,
       getInitialStateMenu,showAccount, addMenuNodes, showFirstContentView, closeCategoryView, 
       openCategoryView, showCategoryView, showContacts, closeContacts, showMessages, setSelectModule,
      closeFirstContentView,showMenuView, setPreviousModule, getInitialStateWithPreviousView, showView, 
      setSelectedModulePrevious, closeQuizActive, closeAllViewCloseQuizActive} = menuSideSlice.actions;
    export default menuSideSlice.reducer;